import { render } from "./ExportarColetaDeFrutosESementes.vue?vue&type=template&id=9fad7122"
import script from "./ExportarColetaDeFrutosESementes.vue?vue&type=script&lang=js"
export * from "./ExportarColetaDeFrutosESementes.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__